// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IPayrollContributionsSummaryRecordDto } from './IPayrollContributionsSummaryRecordDto';
import {
    IPayrollContributionsSummaryRecordDtoFromJSON,
    IPayrollContributionsSummaryRecordDtoFromJSONTyped,
    IPayrollContributionsSummaryRecordDtoToJSON,
    IPayrollContributionsSummaryRecordDtoToJSONTyped,
} from './IPayrollContributionsSummaryRecordDto';

/**
 * 
 * @export
 * @interface IReportSummaryGroupDtoPayrollContributionsSummaryRecordDto
 */
export interface IReportSummaryGroupDtoPayrollContributionsSummaryRecordDto {
    /**
     * 
     * @type {string}
     * @memberof IReportSummaryGroupDtoPayrollContributionsSummaryRecordDto
     */
    subsidiary_name?: string;
    /**
     * 
     * @type {Array<IPayrollContributionsSummaryRecordDto>}
     * @memberof IReportSummaryGroupDtoPayrollContributionsSummaryRecordDto
     */
    subsidiary_records?: Array<IPayrollContributionsSummaryRecordDto>;
}

/**
 * Check if a given object implements the IReportSummaryGroupDtoPayrollContributionsSummaryRecordDto interface.
 */
export function instanceOfIReportSummaryGroupDtoPayrollContributionsSummaryRecordDto(value: object): value is IReportSummaryGroupDtoPayrollContributionsSummaryRecordDto {
    return true;
}

export function IReportSummaryGroupDtoPayrollContributionsSummaryRecordDtoFromJSON(json: any): IReportSummaryGroupDtoPayrollContributionsSummaryRecordDto {
    return IReportSummaryGroupDtoPayrollContributionsSummaryRecordDtoFromJSONTyped(json, false);
}

export function IReportSummaryGroupDtoPayrollContributionsSummaryRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReportSummaryGroupDtoPayrollContributionsSummaryRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'subsidiary_name': json['subsidiary_name'] == null ? undefined : json['subsidiary_name'],
        'subsidiary_records': json['subsidiary_records'] == null ? undefined : ((json['subsidiary_records'] as Array<any>).map(IPayrollContributionsSummaryRecordDtoFromJSON)),
    };
}

export function IReportSummaryGroupDtoPayrollContributionsSummaryRecordDtoToJSON(json: any): IReportSummaryGroupDtoPayrollContributionsSummaryRecordDto {
    return IReportSummaryGroupDtoPayrollContributionsSummaryRecordDtoToJSONTyped(json, false);
}

export function IReportSummaryGroupDtoPayrollContributionsSummaryRecordDtoToJSONTyped(value?: IReportSummaryGroupDtoPayrollContributionsSummaryRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'subsidiary_name': value['subsidiary_name'],
        'subsidiary_records': value['subsidiary_records'] == null ? undefined : ((value['subsidiary_records'] as Array<any>).map(IPayrollContributionsSummaryRecordDtoToJSON)),
    };
}

